import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../constants/api";
import AOS from "aos";
import "aos/dist/aos.css";
import ReactHtmlParser from "react-html-parser";

const ScreenDetail = () => {
  const [products, setProducts] = useState([]);
  const [categoryTitle, setCategoryTitle] = useState("");
  const { title } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
    getBlogs();
  }, [title]);

  const slugify = (text) =>
    String(text || "").toLowerCase().trim().replace(/\s+/g, "-");

  const getBlogs = async () => {
    try {
      // Step 1: Find the category that matches the URL slug
      const catRes = await api.get("/api/categories?pagination[pageSize]=1000");
      const allCategories = catRes?.data?.data || [];

      const matchedCategory = allCategories.find(
        (cat) => slugify(cat.category_title) === title
      );

      console.log("URL title:", title);
      console.log("Matched category:", matchedCategory);

      if (!matchedCategory) {
        console.log("No matching category found for:", title);
        setProducts([]);
        return;
      }

      setCategoryTitle(matchedCategory.category_title);

      // Step 2: Fetch content by category_id
      const contentRes = await api.get(
        `/api/contents?pagination[pageSize]=100&filters[category_id][$eq]=${matchedCategory.id}&filters[published][$eq]=true&sort=sort_order:asc&populate=images`
      );

      const rawData = contentRes?.data?.data || [];
      console.log("Content fetched:", rawData);

      setProducts(rawData);
    } catch (err) {
      console.log("ProductDetails API error:", err);
    }
  };

  return (
    <>
      <section
        className="page-title page-title-overlay bg-cover overflow-hidden"
        data-background="assets/images/background/about.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <h1 className="text-white position-relative">
                {categoryTitle || title.split("-").join(" ")}
              </h1>
            </div>
            <div className="col-lg-3 ml-auto align-self-end">
              <ol className="breadcrumb justify-content-lg-end bg-transparent mb-4 px-0">
                <li
                  className="breadcrumb-item text-white"
                  onClick={() => navigate("/")}
                  style={{ cursor: "pointer" }}
                >
                  Home
                </li>
                <li className="breadcrumb-item text-white fw-bold" aria-current="page">
                  Product Details
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="section pb-0 features">
        <div className="container">
          {products.length === 0 ? (
            <div className="row">
              <div className="col-12 text-center py-5">
                <p>No content available for this category.</p>
              </div>
            </div>
          ) : (
            <div className="row">
              {products.map((data, index) => {
                return (
                  <div
                    key={data.id || index}
                    className={`col-lg-${index === 0 ? "12" : "6"} col-sm-6 mb-4 aos-init aos-animate`}
                    data-aos="fade-up"
                    style={index === 0 ? { textAlign: "center" } : null}
                  >
                    <div className="position-relative px-4 py-5">
                      <h3 className="pb-3 text-capitalize card-title">{data.title}</h3>
                      {data.description && ReactHtmlParser(data.description)}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};
export default ScreenDetail;
